import * as React from 'react'
import { cva } from 'class-variance-authority'
import { cn } from '@/lib/utils'

const BADGE_TONES = {
  neutral: 'border-border bg-muted text-muted-foreground',
  accent: 'border-info-border bg-primary-subtle text-link',
  success: 'border-success-border bg-success-subtle text-success',
  warning: 'border-warning-border bg-warning-subtle text-warning',
  danger: 'border-danger-border bg-danger-subtle text-danger',
  info: 'border-info-border bg-info-subtle text-info',
}

/** Status color. `null` is not a tone; omit the prop for neutral. */
export type BadgeTone = keyof typeof BADGE_TONES

/** Muted status pairs only: soft background, darker text, matching border. */
export const badgeVariants = cva(
  'inline-flex items-center gap-1 rounded-md border px-1.5 py-0.5 text-caption font-medium whitespace-nowrap [&_svg]:size-3',
  {
    variants: { tone: BADGE_TONES },
    defaultVariants: { tone: 'neutral' },
  },
)

export interface BadgeProps extends React.ComponentProps<'span'> {
  tone?: BadgeTone
}

/** A small status or role label. */
export function Badge({ ref, className, tone, ...props }: BadgeProps) {
  return <span ref={ref} className={cn(badgeVariants({ tone }), className)} {...props} />
}
